(function (globalScope, factory) {
  var api = factory(globalScope);

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (globalScope) {
    globalScope.theme = globalScope.theme || {};
    globalScope.theme.productBundleV2 = api;
  }
})(typeof window !== 'undefined' ? window : null, function (globalScope) {
  'use strict';

  var PREFIX = 'mon2';
  var CASE_COUNT = 4;
  // Bundle Envelope variant for each Monthly page: regular and Secret Menu.
  var CARRIER_VARIANT_IDS = {
    'bundle-listing': '48914860048616',
    'secret-menu-bundle-listing': '50512484303080'
  };
  var CARRIER_PRODUCT_ID = '9602892431592';
  var CASE_PRODUCT_ID = '9105064198376';
  var CASE_FETCH_TIER = 'Single Pack';
  var LID_PRODUCT_ID = '9127873478888';
  var POCKET_PRODUCT_ID = '9110283780328';
  var BUNDLE_NUMBER_KEY = 'Monthly Bundle #';
  var BUNDLE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SIZE_KEY_CODES = {
    'weekly-xs-case': 'WXSPC',
    'weekly-pill-case': 'WPC',
    'weekly-vitamin-case': 'WVC',
    'weekly-vitamin-xl-case': 'WVXC',
    'weekly-vitamin-2xl-case': 'WV2XC'
  };
  // Included engraving uses the shared survivor listings, one variant per case size.
  // Cart Transform prices it at $0; the start day rides on the case lines.
  var LID_RULES = {
    WXSPC: { id: '49100613779688', sku: 'ENG-LID-WXSPC-MNTH' },
    WPC: { id: '49100613812456', sku: 'ENG-LID-WPC-MNTH' },
    WVC: { id: '49100613845224', sku: 'ENG-LID-WVC-MNTH' },
    WVXC: { id: '49100613877992', sku: 'ENG-LID-WVXC-MNTH' },
    WV2XC: { id: '49100613910760', sku: 'ENG-LID-WV2XC-MNTH' }
  };
  var POCKET_RULES = {
    WXSPC: { id: '49100613943528', sku: 'ENG-IPE-WXSPC-MNTH' },
    WPC: { id: '49100613976296', sku: 'ENG-IPE-WPC-MNTH' },
    WVC: { id: '49100614009064', sku: 'ENG-IPE-WVC-MNTH' },
    WVXC: { id: '49100614041832', sku: 'ENG-IPE-WVXC-MNTH' },
    WV2XC: { id: '49100614074600', sku: 'ENG-IPE-WV2XC-MNTH' }
  };
  var DAY_CODES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  var MONTHLY_LID_LABELS = ['WEEK 1', 'WEEK 2', 'WEEK 3', 'WEEK 4'];
  var PREVIEW_SIZES = {
    'weekly-xs-case': { main: '320px', mainMobile: '240px', body: '210px' },
    'weekly-pill-case': { main: '350px', mainMobile: '263px', body: '225px' },
    'weekly-vitamin-case': { main: '420px', mainMobile: '315px', body: '255px' },
    'weekly-vitamin-xl-case': { main: '420px', mainMobile: '315px', body: '255px' },
    'weekly-vitamin-2xl-case': { main: '480px', mainMobile: '360px', body: '285px' }
  };
  var LID_PREVIEW_FONT_SIZES = {
    'weekly-xs-case': { main: 30, mainMobile: 24, header: 15, body: 20 },
    'weekly-pill-case': { main: 31, mainMobile: 26, header: 16, body: 20 },
    'weekly-vitamin-case': { main: 42, mainMobile: 30, header: 18, body: 24 },
    'weekly-vitamin-xl-case': { main: 42, mainMobile: 30, header: 18, body: 24 },
    'weekly-vitamin-2xl-case': { main: 44, mainMobile: 36, header: 20, body: 27 }
  };
  var PREVIEW_RADIUS = '12px';
  var FOCUS_RING = 'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-gray-950 tw:focus-visible:ring-offset-1';
  var FOCUS_RING_INSET = 'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-gray-950';

  function normalizeListingContext(value) {
    var normalized = String(value || '').trim().toLowerCase();
    var allowed = [
      'single-listing',
      'bundle-listing',
      'free-nano-listing',
      'secret-menu-listing',
      'secret-menu-bundle-listing'
    ];
    return allowed.indexOf(normalized) !== -1 ? normalized : '';
  }

  function isAluminumColor(colorName) {
    return String(colorName || '').trim().toLowerCase() === 'aluminum';
  }

  function getLidPreviewLabelStyle(colorName) {
    return {
      color: 'transparent',
      textStroke: '1px ' + (isAluminumColor(colorName) ? '#a3a3a3' : '#d3d3d3')
    };
  }

  function buildSizeFetchArgs(handle, listingContext) {
    return [
      'combined',
      String(handle || ''),
      'sizes',
      CASE_FETCH_TIER,
      normalizeListingContext(listingContext),
      'single',
      '',
      '',
      normalizeListingContext(listingContext)
    ];
  }

  function buildColorFetchArgs(handle, sizeKey, listingContext) {
    return [
      'combined',
      String(handle || ''),
      'colors',
      String(sizeKey || ''),
      CASE_FETCH_TIER,
      'listing',
      normalizeListingContext(listingContext),
      'single',
      '',
      '',
      normalizeListingContext(listingContext)
    ];
  }

  function getColorSortIndex(color) {
    if (!color || color.sort_index === null || color.sort_index === undefined) return null;
    var raw = String(color.sort_index).trim();
    if (!raw) return null;
    var parsed = Number(raw);
    return isFinite(parsed) ? parsed : null;
  }

  function getSortedColorList(catalog) {
    return (catalog || []).map(function (color, sourceIndex) {
      return {
        color: color,
        sourceIndex: sourceIndex,
        sortIndex: getColorSortIndex(color)
      };
    }).sort(function (left, right) {
      var leftUnavailable = !!left.color.sold_out || !left.color.variant;
      var rightUnavailable = !!right.color.sold_out || !right.color.variant;
      if (leftUnavailable !== rightUnavailable) return leftUnavailable ? 1 : -1;
      var leftSecretPriority = !!left.color.secret_menu_priority;
      var rightSecretPriority = !!right.color.secret_menu_priority;
      if (leftSecretPriority !== rightSecretPriority) return leftSecretPriority ? -1 : 1;
      if (left.sortIndex !== null && right.sortIndex !== null && left.sortIndex !== right.sortIndex) {
        return left.sortIndex - right.sortIndex;
      }
      if (left.sortIndex !== null && right.sortIndex === null) return -1;
      if (left.sortIndex === null && right.sortIndex !== null) return 1;
      return left.sourceIndex - right.sourceIndex;
    }).map(function (entry) {
      return entry.color;
    });
  }

  function colorIsSoldOut(color) {
    return !!(color && (color.sold_out || !color.variant));
  }

  function getRemainingSellableCap(variant, reserved, capResolver) {
    var cap = typeof capResolver === 'function' ? capResolver(variant) : getSellableCap(variant);
    if (!Number.isFinite(cap)) return cap;
    var id = toVariantId(variant && variant.id);
    var alreadyReserved = id && reserved ? Math.max(0, Math.trunc(Number(reserved[id]) || 0)) : 0;
    return Math.max(0, cap - alreadyReserved);
  }

  function countVariantSelections(variants, variantId, excludedIndex) {
    return (variants || []).reduce(function (count, variant, index) {
      if (index === excludedIndex) return count;
      return count + (toVariantId(variant && variant.id) === variantId ? 1 : 0);
    }, 0);
  }

  function canAllocateVariant(variant, selectedVariants, reserved, excludedIndex, capResolver) {
    var id = toVariantId(variant && variant.id);
    if (!id || variant.available === false) return false;
    var remainingCap = getRemainingSellableCap(variant, reserved, capResolver);
    if (!Number.isFinite(remainingCap)) return true;
    return countVariantSelections(selectedVariants, id, excludedIndex) < remainingCap;
  }

  function getDefaultColor(catalog, reserved, requiredQuantity, capResolver) {
    var availableColors = getSortedColorList(catalog).filter(function (color) {
      return !colorIsSoldOut(color);
    });
    var required = Math.max(1, Math.trunc(Number(requiredQuantity) || CASE_COUNT));
    return availableColors.find(function (color) {
      return getRemainingSellableCap(color.variant, reserved, capResolver) >= required;
    }) || availableColors.find(function (color) {
      return canAllocateVariant(color.variant, [], reserved, undefined, capResolver);
    }) || null;
  }

  function allocateColorSelections(catalog, preferredSelections, reserved, count, capResolver) {
    var selectionCount = Math.max(0, Math.trunc(Number(count) || 0));
    var colors = getSortedColorList(catalog).filter(function (color) {
      return !colorIsSoldOut(color);
    });
    var defaultColor = getDefaultColor(colors, reserved, selectionCount || CASE_COUNT, capResolver);
    var candidates = defaultColor
      ? [defaultColor].concat(colors.filter(function (color) { return color.key !== defaultColor.key; }))
      : colors;
    var selectedVariants = [];

    return Array.from({ length: selectionCount }, function (_, index) {
      var preferred = preferredSelections && preferredSelections[index];
      var refreshedPreferred = preferred && colors.find(function (color) { return color.key === preferred.key; });
      var selected = refreshedPreferred && canAllocateVariant(refreshedPreferred.variant, selectedVariants, reserved, undefined, capResolver)
        ? refreshedPreferred
        : candidates.find(function (color) {
          return canAllocateVariant(color.variant, selectedVariants, reserved, undefined, capResolver);
        }) || null;
      selectedVariants.push(selected && selected.variant || null);
      return selected;
    });
  }

  function orderedDayCodes(startDay) {
    var startIndex = DAYS.indexOf(String(startDay || ''));
    if (startIndex < 0) return [];
    return DAY_CODES.slice(startIndex).concat(DAY_CODES.slice(0, startIndex));
  }

  function toLookupKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseSizeOrder(text) {
    return String(text || '').split(/[\r\n,]+/).map(toLookupKey).filter(function (key, index, keys) {
      return key && keys.indexOf(key) === index;
    });
  }

  function orderSizeKeys(keys, order) {
    return keys.map(function (key, index) {
      var rank = order.indexOf(key);
      return { key: key, index: index, rank: rank < 0 ? order.length : rank };
    }).sort(function (a, b) {
      return a.rank - b.rank || a.index - b.index;
    }).map(function (entry) { return entry.key; });
  }

  function toVariantId(value) {
    var raw = String(value == null ? '' : value).trim();
    var id = raw.split('/').pop();
    return /^[1-9]\d*$/.test(id || '') ? id : null;
  }

  function parsePositiveInt(value) {
    var normalized = String(value == null ? '' : value).trim();
    if (!/^[1-9]\d*$/.test(normalized)) return null;
    var parsed = Number(normalized);
    return Number.isSafeInteger(parsed) ? parsed : null;
  }

  function parseMarker(value) {
    if (typeof value !== 'string') return null;
    var parts = value.trim().split(':');
    if (parts[0] !== PREFIX || !BUNDLE_ID_PATTERN.test(parts[1] || '')) return null;
    if (parts.length === 2) return { bundleId: parts[1], role: 'parent' };
    if (parts.length === 3 && (parts[2] === 'lid' || parts[2] === 'pocket')) {
      return { bundleId: parts[1], role: parts[2] };
    }
    if (parts.length === 4 && parts[2] === 'case' && /^[1-4]$/.test(parts[3])) {
      return { bundleId: parts[1], role: 'case', slot: Number(parts[3]) };
    }
    return null;
  }

  function buildMarker(bundleId, role, slot) {
    if (!BUNDLE_ID_PATTERN.test(String(bundleId || ''))) {
      throw new Error('The Monthly bundle ID is invalid.');
    }
    var marker = PREFIX + ':' + bundleId;
    if (!role || role === 'parent') return marker;
    if (role === 'case') {
      if (!Number.isInteger(slot) || slot < 1 || slot > CASE_COUNT) {
        throw new Error('The Monthly case slot is invalid.');
      }
      return marker + ':case:' + slot;
    }
    if (role === 'lid' || role === 'pocket') return marker + ':' + role;
    throw new Error('The Monthly bundle role is invalid.');
  }

  function secureToken(scope) {
    if (!scope || !scope.crypto || typeof scope.crypto.getRandomValues !== 'function') {
      throw new Error('Secure bundle ID generation is unavailable.');
    }
    var words = new Uint32Array(2);
    scope.crypto.getRandomValues(words);
    return words[0].toString(36) + words[1].toString(36);
  }

  function createBundleIdFactory(options) {
    var settings = options || {};
    var counter = 0;
    return function () {
      counter += 1;
      var now = typeof settings.now === 'function' ? settings.now() : Date.now();
      var token = typeof settings.randomToken === 'function'
        ? settings.randomToken()
        : secureToken(globalScope);
      var value = [
        'm',
        Math.max(0, Number(now) || 0).toString(36),
        counter.toString(36),
        String(token || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 18)
      ].join('_').slice(0, 64);
      if (!BUNDLE_ID_PATTERN.test(value)) throw new Error('Could not create a Monthly bundle ID.');
      return value;
    };
  }

  var createBundleId = createBundleIdFactory();

  function itemProperties(item) {
    return item && item.properties && typeof item.properties === 'object'
      ? item.properties
      : {};
  }

  function itemVariantId(item) {
    if (!item) return null;
    return toVariantId(item.variant_id || item.variantId || item.id || (item.merchandise && item.merchandise.id));
  }

  function itemQuantity(item) {
    var quantity = Number(item && item.quantity);
    return Number.isFinite(quantity) && quantity > 0 ? Math.trunc(quantity) : 0;
  }

  function getNextMonthlyBundleNumber(items) {
    var parentCount = 0;
    var highest = 0;
    (items || []).forEach(function (item) {
      var marker = parseMarker(itemProperties(item)._ikg_bundle);
      if (!marker || marker.role !== 'parent') return;
      parentCount += 1;
      var rawNumber = itemProperties(item)[BUNDLE_NUMBER_KEY];
      if (rawNumber == null || String(rawNumber).trim() === '') return;
      var parsed = parsePositiveInt(rawNumber);
      if (parsed == null) throw new Error('An existing Monthly bundle has an invalid bundle number.');
      highest = Math.max(highest, parsed);
    });
    return Math.max(parentCount, highest) + 1;
  }

  function getSellableCap(variant) {
    if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
      return Infinity;
    }
    var quantity = Math.trunc(Number(variant.inventory_quantity) || 0);
    return Math.max(0, quantity);
  }

  function aggregateDemand(variants) {
    var demand = {};
    (variants || []).forEach(function (variant) {
      var id = toVariantId(variant && variant.id);
      if (!id) return;
      if (!demand[id]) demand[id] = { variant: variant, quantity: 0 };
      demand[id].quantity += 1;
    });
    return demand;
  }

  function reservedQuantities(cartItems) {
    var reserved = {};
    (cartItems || []).forEach(function (item) {
      var id = itemVariantId(item);
      if (!id) return;
      reserved[id] = (reserved[id] || 0) + itemQuantity(item);
    });
    return reserved;
  }

  function validateAggregateInventory(variants, cartItems) {
    var demand = aggregateDemand(variants);
    var reserved = reservedQuantities(cartItems);
    var issues = [];
    var preorderVariantIds = [];

    Object.keys(demand).forEach(function (id) {
      var entry = demand[id];
      var variant = entry.variant;
      var requested = entry.quantity;
      var alreadyReserved = reserved[id] || 0;
      var cap = getSellableCap(variant);
      if (variant.available === false && variant.inventory_policy !== 'continue') {
        issues.push('A selected color is sold out.');
        return;
      }
      if (Number.isFinite(cap) && alreadyReserved + requested > cap) {
        issues.push('Only ' + Math.max(0, cap - alreadyReserved) + ' more of this selected color can be added.');
        return;
      }
      if (variant.inventory_management && variant.inventory_policy === 'continue') {
        var rawInventory = Math.max(0, Math.trunc(Number(variant.inventory_quantity) || 0));
        if (alreadyReserved + requested > rawInventory) preorderVariantIds.push(id);
      }
    });

    return {
      ok: issues.length === 0,
      issues: issues,
      demand: demand,
      reserved: reserved,
      preorderVariantIds: preorderVariantIds
    };
  }

  function findExactVariant(product, rule) {
    if (!product || !Array.isArray(product.variants) || !rule) return null;
    return product.variants.find(function (variant) {
      return toVariantId(variant.id) === rule.id && String(variant.sku || '').trim() === rule.sku;
    }) || null;
  }

  function validateIncludedVariant(product, rule, label) {
    var variant = findExactVariant(product, rule);
    if (!variant) return label + ' mapping is unavailable.';
    if (variant.available !== true) return label + ' variant is unavailable.';
    return '';
  }

  function validateFixedCatalog(options) {
    var settings = options || {};
    var issues = [];
    if (String(settings.caseProductId || '') !== CASE_PRODUCT_ID) issues.push('Select the authorized Weekly Case product.');
    if (String(settings.carrierProductId || '') !== CARRIER_PRODUCT_ID) issues.push('Select the authorized Bundle Envelope product.');
    if (toVariantId(settings.carrierVariantId) !== CARRIER_VARIANT_IDS[settings.listingContext]) issues.push('Select the authorized Monthly carrier variant.');
    if (Number(settings.carrierPrice) !== 0) issues.push('The Monthly carrier catalog price must be $0.');
    if (settings.carrierAvailable === false) issues.push('The Monthly carrier is unavailable.');
    if (!(Number(settings.bundlePriceCents) > 0)) issues.push('The Monthly bundle price metafield is unavailable.');
    if (String(settings.lidProduct && settings.lidProduct.id || '') !== LID_PRODUCT_ID) {
      issues.push('Select the authorized Monthly lid engraving product.');
    }
    if (String(settings.pocketProduct && settings.pocketProduct.id || '') !== POCKET_PRODUCT_ID) {
      issues.push('Select the authorized Monthly pocket engraving product.');
    }
    Object.keys(LID_RULES).forEach(function (sizeCode) {
      var lidIssue = validateIncludedVariant(settings.lidProduct, LID_RULES[sizeCode], 'The Monthly lid engraving for ' + sizeCode);
      if (lidIssue) issues.push(lidIssue);
      var pocketIssue = validateIncludedVariant(settings.pocketProduct, POCKET_RULES[sizeCode], 'The Monthly pocket engraving for ' + sizeCode);
      if (pocketIssue) issues.push(pocketIssue);
    });
    return { ok: issues.length === 0, issues: issues };
  }

  function buildCartItems(options) {
    var settings = options || {};
    var bundleId = String(settings.bundleId || '');
    var bundleNumber = parsePositiveInt(settings.bundleNumber);
    var carrierId = toVariantId(settings.carrierVariantId);
    var sizeCode = String(settings.sizeCode || '');
    var cases = Array.isArray(settings.cases) ? settings.cases.slice() : [];
    var preorderIds = new Set(settings.preorderVariantIds || []);
    if (!BUNDLE_ID_PATTERN.test(bundleId)) throw new Error('The Monthly bundle ID is invalid.');
    if (!bundleNumber) throw new Error('The Monthly bundle number is invalid.');
    if (carrierId !== CARRIER_VARIANT_IDS[settings.listingContext]) throw new Error('The Monthly carrier is invalid.');
    if (!LID_RULES[sizeCode]) throw new Error('The Monthly case size is invalid.');
    if (cases.length !== CASE_COUNT) throw new Error('Select exactly four Monthly cases.');
    if (settings.pocket && DAYS.indexOf(settings.startDay) === -1) throw new Error('The Monthly start day is invalid.');

    cases.sort(function (left, right) { return Number(left.slot) - Number(right.slot); });
    var slots = new Set();
    cases.forEach(function (entry) {
      var slot = Number(entry.slot);
      if (!Number.isInteger(slot) || slot < 1 || slot > CASE_COUNT || slots.has(slot)) {
        throw new Error('The Monthly case slots are invalid.');
      }
      if (!toVariantId(entry.variant && entry.variant.id)) throw new Error('A Monthly case variant is missing.');
      slots.add(slot);
    });

    var numberValue = String(bundleNumber);
    var items = [{
      id: Number(carrierId),
      quantity: 1,
      properties: {
        _ikg_bundle: buildMarker(bundleId),
        'Monthly Bundle #': numberValue
      }
    }];

    cases.forEach(function (entry) {
      var slot = Number(entry.slot);
      var variantId = toVariantId(entry.variant.id);
      var properties = {
        _ikg_bundle: buildMarker(bundleId, 'case', slot),
        'Monthly Bundle #': numberValue,
        'Pill Case': '#' + slot
      };
      if (settings.lid) properties['Lid Engraving'] = 'WEEK ' + slot;
      if (settings.pocket) properties['Pill Case #' + slot + ' - DOTW'] = settings.startDay;
      if (settings.preorderEta && preorderIds.has(variantId)) {
        properties.Preorder = settings.preorderEta;
      }
      items.push({
        id: Number(variantId),
        quantity: 1,
        parent_id: Number(carrierId),
        properties: properties
      });
    });

    if (settings.lid) {
      var lidRule = LID_RULES[sizeCode];
      var lidVariant = settings.lid.variant;
      if (!lidVariant || toVariantId(lidVariant.id) !== lidRule.id || String(lidVariant.sku || '') !== lidRule.sku) {
        throw new Error('The Monthly lid engraving variant is invalid.');
      }
      items.push({
        id: Number(lidRule.id),
        quantity: 1,
        parent_id: Number(carrierId),
        properties: {
          _ikg_bundle: buildMarker(bundleId, 'lid'),
          'Monthly Bundle #': numberValue
        }
      });
    }

    if (settings.pocket) {
      var pocketRule = POCKET_RULES[sizeCode];
      var pocketVariant = settings.pocket.variant;
      if (!pocketVariant || toVariantId(pocketVariant.id) !== pocketRule.id || String(pocketVariant.sku || '') !== pocketRule.sku) {
        throw new Error('The Monthly pocket engraving variant is invalid.');
      }
      items.push({
        id: Number(pocketRule.id),
        quantity: 1,
        parent_id: Number(carrierId),
        properties: {
          _ikg_bundle: buildMarker(bundleId, 'pocket'),
          'Monthly Bundle #': numberValue
        }
      });
    }

    return items;
  }

  function responseItems(payload) {
    if (payload && Array.isArray(payload.items)) return payload.items;
    return Array.isArray(payload) ? payload : [];
  }

  function inspectCartAddResponse(payload, submittedItems) {
    var issues = [];
    var returned = responseItems(payload);
    var submitted = submittedItems || [];
    if (returned.length !== submitted.length) issues.push('Shopify returned a different Monthly line count.');

    var expectedMarkers = submitted.map(function (item) { return itemProperties(item)._ikg_bundle || ''; });
    var actualMarkers = returned.map(function (item) { return itemProperties(item)._ikg_bundle || ''; });
    if (expectedMarkers.join('|') !== actualMarkers.join('|')) {
      issues.push('Shopify returned the Monthly lines in a different order.');
    }
    var expectedIds = submitted.map(itemVariantId);
    var actualIds = returned.map(itemVariantId);
    if (expectedIds.join('|') !== actualIds.join('|')) {
      issues.push('Shopify returned different Monthly merchandise.');
    }

    var parentMarker = expectedMarkers[0];
    var parents = returned.filter(function (item) {
      return itemProperties(item)._ikg_bundle === parentMarker;
    });
    var parent = parents[0];
    if (parents.length !== 1 || !parent || !parent.key) {
      issues.push('Shopify did not return exactly one Monthly carrier line.');
    } else {
      returned.forEach(function (item) {
        if (!item || item === parent) return;
        var relationship = item.parent_relationship || item.parentRelationship;
        var parentKey = relationship && (relationship.parent_key || relationship.parentKey);
        if (parentKey !== parent.key) issues.push('A Monthly child is not attached to the returned carrier.');
      });
    }
    return { ok: issues.length === 0, issues: issues };
  }

  function createState() {
    return {
      sizes: [],
      colors: [],
      pendingSize: null,
      size: null,
      selectedColors: [null, null, null, null],
      selectedVariants: [null, null, null, null],
      lidChoice: 'add',
      pocketChoice: 'skip',
      startDay: 'Sunday',
      confirmed: { size: false, colors: false, lid: false, pocket: false },
      inventory: null,
      cartItems: [],
      cartReserved: {},
      adding: false
    };
  }

  function invalidateAfter(state, step) {
    if (!state || !state.confirmed) return state;
    if (step === 'size') {
      state.size = null;
      state.selectedColors = [null, null, null, null];
      state.selectedVariants = [null, null, null, null];
      state.confirmed.size = false;
      state.confirmed.colors = false;
      state.confirmed.lid = false;
      state.confirmed.pocket = false;
    } else if (step === 'colors') {
      state.confirmed.colors = false;
      state.confirmed.lid = false;
      state.confirmed.pocket = false;
    } else if (step === 'lid') {
      state.confirmed.lid = false;
      state.confirmed.pocket = false;
    } else if (step === 'pocket') {
      state.confirmed.pocket = false;
    }
    if (step === 'size' || step === 'colors') state.inventory = null;
    return state;
  }

  function cartRoute(path) {
    var root = globalScope && globalScope.Shopify && globalScope.Shopify.routes
      ? globalScope.Shopify.routes.root
      : '/';
    root = String(root || '/').replace(/\/?$/, '/');
    return root + String(path || '').replace(/^\/+/, '');
  }

  function parseResponse(response, fallback) {
    if (response.ok) return response.json();
    return response.json().catch(function () { return {}; }).then(function (payload) {
      throw new Error(payload.description || payload.message || fallback);
    });
  }

  function init(root, config) {
    if (!root || root.getAttribute('data-product-bundle-v2-ready') === 'true') return null;
    root.setAttribute('data-product-bundle-v2-ready', 'true');

    config.listingContext = normalizeListingContext(config.listingContext);
    var sizeOrder = parseSizeOrder(config.sizeOrder);
    var unmatched = sizeOrder.filter(function (key) { return Object.keys(SIZE_KEY_CODES).indexOf(key) < 0; });
    if (unmatched.length) console.warn('[Monthly Bundle V2] Size order matches no size on this page:', unmatched.join(', '));

    var state = createState();
    var sizeList = root.querySelector('[data-size-list]');
    var sizeStep = globalScope.theme && globalScope.theme.sizeStep;
    var sizeBar = null;
    var colorList = root.querySelector('[data-color-list]');
    var atc = root.querySelector('[data-add-to-cart]');
    var atcLabel = root.querySelector('[data-add-to-cart-label]');
    var atcSpinner = root.querySelector('[data-add-to-cart-spinner]');
    var atcMessage = root.querySelector('[data-add-to-cart-message]');
    var atcError = root.querySelector('[data-add-to-cart-error]');
    var stockPill = root.querySelector('[data-stock-pill]');
    var stockLabel = root.querySelector('[data-stock-label]');
    var configError = root.querySelector('[data-config-error]');
    var galleryStage = root.querySelector('[data-gallery-stage]');
    var primaryMedia = root.querySelector('[data-primary-media]');
    var primaryPlaceholder = root.querySelector('[data-primary-placeholder]');
    var previewFrame = root.querySelector('[data-monthly-preview-frame]');
    var initialPrimarySrc = primaryMedia ? primaryMedia.getAttribute('src') || '' : '';
    var initialPrimaryAlt = primaryMedia ? primaryMedia.getAttribute('alt') || '' : '';
    var lidProduct = config.lidProduct || null;
    var pocketProduct = config.pocketProduct || null;
    var pocketImagesByColor = config.pocketImages || {};
    var caseImagesByColor = config.caseImages || {};
    var fixedCatalog = validateFixedCatalog({
      caseProductId: config.caseProductId,
      carrierProductId: config.carrierProductId,
      carrierVariantId: config.carrierVariantId,
      listingContext: config.listingContext,
      carrierPrice: config.carrierPrice,
      carrierAvailable: config.carrierAvailable,
      bundlePriceCents: config.bundlePriceCents,
      lidProduct: lidProduct,
      pocketProduct: pocketProduct
    });
    var sizeLoading = false;
    var sizeError = '';
    var colorLoading = false;
    var colorError = '';
    var activeStep = '1';
    var openColorPopover = null;
    var colorPopoverListenersBound = false;
    var currentTooltip = null;
    var currentTooltipTrigger = null;
    var previewSize = null;
    var previewColor = null;
    var previewRequestId = 0;

    function getSelectionCap(variant) {
      var preorderConfigured = !!(config.preorderEnabled && String(config.preorderEta || '').trim());
      if (variant && variant.inventory_management && variant.inventory_policy === 'continue' && !preorderConfigured) {
        return Math.max(0, Math.trunc(Number(variant.inventory_quantity) || 0));
      }
      return getSellableCap(variant);
    }

    function setMessage(message) {
      if (!atcMessage) return;
      atcMessage.textContent = message || '';
      if (atcError) {
        atcError.classList.toggle('tw:hidden', !message);
        atcError.setAttribute('aria-hidden', message ? 'false' : 'true');
      }
    }

    function setValidation(step, message) {
      var el = root.querySelector('[data-step-validation="' + step + '"]');
      if (!el) return;
      el.textContent = message || '';
      el.classList.toggle('tw:hidden', !message);
    }

    function setStock(status, label) {
      if (stockPill) stockPill.setAttribute('data-stock-status', status);
      if (stockLabel) stockLabel.textContent = label;
    }

    function refreshStock() {
      if (!fixedCatalog.ok) {
        setStock('outstock', 'Out of stock');
        return;
      }
      if (!state.sizes.length) return;
      var hasAvailableSize = state.sizes.some(function (size) { return size && !size.sold_out; });
      setStock(hasAvailableSize ? 'instock' : 'outstock', hasAvailableSize ? 'In stock' : 'Out of stock');
    }

    function stepUnlocked(step) {
      if (step === '1') return true;
      if (step === '2') return state.confirmed.size;
      if (step === '3') return state.confirmed.colors;
      if (step === '4') return state.confirmed.lid;
      return false;
    }

    function focusElementSoon(element) {
      if (!element || typeof element.focus !== 'function') return;
      var focus = function () {
        try {
          element.focus({ preventScroll: false });
        } catch (error) {
          element.focus();
        }
      };
      if (globalScope.requestAnimationFrame) globalScope.requestAnimationFrame(focus);
      else globalScope.setTimeout(focus, 0);
    }

    function setStepBodyVisible(step, visible) {
      var body = root.querySelector('[data-step-body="' + step + '"]');
      var header = root.querySelector('[data-step-header="' + step + '"]');
      if (!body) return;
      if (!visible && body.contains(document.activeElement)) {
        if (header && !header.disabled) focusElementSoon(header);
        else if (document.activeElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
      }
      body.hidden = false;
      body.classList.toggle('tw:grid-rows-[1fr]', visible);
      body.classList.toggle('tw:grid-rows-[0fr]', !visible);
      body.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) body.removeAttribute('inert');
      else body.setAttribute('inert', '');
      if (header) header.setAttribute('aria-expanded', visible ? 'true' : 'false');
    }

    function applyStepVisualState(step, active, touched, locked) {
      var card = root.querySelector('[data-step="' + step + '"]');
      if (!card) return;
      var header = root.querySelector('[data-step-header="' + step + '"]');
      var badge = card.querySelector('[data-step-badge]');
      var chevron = card.querySelector('[data-step-chevron]');
      var confirmed = touched && !active && !locked;
      var pending = !active && !confirmed;

      card.classList.toggle('tw:border-blue-300', active);
      card.classList.toggle('tw:border-green-300', confirmed);
      card.classList.toggle('tw:border-gray-300', pending);
      card.classList.toggle('tw:ring-1', active || confirmed);
      card.classList.toggle('tw:ring-blue-300', active);
      card.classList.toggle('tw:ring-green-300', confirmed);
      card.classList.toggle('tw:shadow-sm', active || confirmed);

      if (header) {
        header.disabled = locked;
        header.classList.toggle('tw:opacity-50', locked);
        header.classList.toggle('tw:cursor-not-allowed', locked);
        header.classList.toggle('tw:bg-blue-50', active);
        header.classList.toggle('tw:bg-green-50', confirmed);
        header.classList.toggle('tw:bg-gray-50', pending);
        header.classList.toggle('tw:text-gray-800', active || confirmed);
        header.classList.toggle('tw:text-gray-700', pending);
      }
      if (badge) {
        badge.setAttribute('data-state', active ? 'active' : confirmed ? 'confirmed' : 'pending');
        badge.classList.toggle('tw:text-gray-800', active || confirmed);
        badge.classList.toggle('tw:text-gray-700', pending);
        var check = badge.querySelector('[data-badge-check]');
        if (check) {
          check.classList.toggle('tw:hidden', !confirmed);
          check.classList.toggle('tw:inline-flex', confirmed);
        }
      }
      if (chevron) {
        chevron.classList.toggle('tw:rotate-180', active);
        chevron.classList.toggle('tw:text-blue-700', active);
        chevron.classList.toggle('tw:text-green-700', confirmed);
        chevron.classList.toggle('tw:text-gray-500', pending);
      }
    }

    function openStep(step, options) {
      options = options || {};
      if (!stepUnlocked(step)) return;
      activeStep = String(step);
      renderSteps();
      if (options.focusHeader) focusElementSoon(root.querySelector('[data-step-header="' + step + '"]'));
    }

    function summaryText(step) {
      if (step === '1' && state.confirmed.size) {
        var size = state.sizes.find(function (entry) { return entry.key === state.size; });
        return size ? (size.display_name || size.label) : '';
      }
      if (step === '2' && state.confirmed.colors) {
        return state.selectedColors.map(function (entry) { return entry && entry.name; }).join(' · ');
      }
      if (step === '3' && state.confirmed.lid) return state.lidChoice === 'add' ? 'Lid engraving' : 'No engraving';
      if (step === '4' && state.confirmed.pocket) return state.pocketChoice === 'add' ? state.startDay : 'No engraving';
      return '';
    }

    function renderStepSummary(step, value, touched) {
      var summary = root.querySelector('[data-step-summary="' + step + '"]');
      if (!summary) return;
      summary.innerHTML = '';
      if (!value || !touched) {
        summary.classList.add('tw:hidden');
        summary.removeAttribute('data-summary-value');
        summary.removeAttribute('aria-label');
        return;
      }
      var label = document.createElement('span');
      label.className = 'tw:font-normal tw:text-gray-600';
      label.textContent = 'Selected: ';
      var selected = document.createElement('span');
      selected.className = 'tw:font-bold tw:text-black';
      selected.textContent = value;
      summary.appendChild(label);
      summary.appendChild(selected);
      summary.setAttribute('data-summary-value', value);
      summary.setAttribute('aria-label', 'Selected: ' + value);
      summary.classList.remove('tw:hidden');
    }

    function renderStepSummaryContent(step, value, content, touched) {
      var summary = root.querySelector('[data-step-summary="' + step + '"]');
      if (!summary) return;
      summary.innerHTML = '';
      if (!value || !content || !touched) {
        summary.classList.add('tw:hidden');
        summary.removeAttribute('data-summary-value');
        summary.removeAttribute('aria-label');
        return;
      }
      summary.appendChild(content);
      summary.setAttribute('data-summary-value', value);
      summary.setAttribute('aria-label', 'Selected: ' + value);
      summary.classList.remove('tw:hidden');
    }

    function renderColorStepSummary(touched) {
      var value = summaryText('2');
      var stack = createPreviewStack('colorHeader');
      if (!stack) {
        renderStepSummary('2', value, touched);
        return;
      }
      var wrap = document.createElement('span');
      wrap.setAttribute('data-color-header-preview', '');
      wrap.className = 'tw:flex tw:w-full tw:min-w-0 tw:items-center';
      wrap.appendChild(stack);
      renderStepSummaryContent('2', value, wrap, touched);
    }

    function renderLidStepSummary(touched) {
      var value = state.lidChoice === 'add'
        ? MONTHLY_LID_LABELS.join('|')
        : 'No lid engraving';
      var stack = createPreviewStack('lidHeader');
      if (!stack) {
        renderStepSummary('3', value, touched);
        return;
      }
      var wrap = document.createElement('span');
      wrap.setAttribute('data-lid-header-preview', '');
      wrap.className = 'tw:flex tw:w-full tw:min-w-0 tw:items-center';
      wrap.appendChild(stack);
      renderStepSummaryContent('3', value, wrap, touched);
    }

    function renderPocketStepSummary(touched) {
      var rows = getPocketPreviewRows();
      var value = state.pocketChoice === 'add'
        ? 'DOTW:' + state.startDay
        : 'No pocket engraving';
      renderStepSummaryContent('4', value, createPocketStepSummaryPreview(rows), touched);
    }

    function renderSteps() {
      ['1', '2', '3', '4'].forEach(function (step) {
        var card = root.querySelector('[data-step="' + step + '"]');
        var unlocked = stepUnlocked(step);
        var active = activeStep === step && unlocked;
        var touched = step === '1' ? state.confirmed.size
          : step === '2' ? state.confirmed.colors
            : step === '3' ? state.confirmed.lid
              : state.confirmed.pocket;
        if (card) {
          card.setAttribute('data-locked', unlocked ? 'false' : 'true');
          card.setAttribute('data-active', active ? 'true' : 'false');
          card.setAttribute('data-touched', touched ? 'true' : 'false');
        }
        setStepBodyVisible(step, active);
        if (step === '2') renderColorStepSummary(touched);
        else if (step === '3') renderLidStepSummary(touched);
        else if (step === '4') renderPocketStepSummary(touched);
        else renderStepSummary(step, summaryText(step), touched);
        applyStepVisualState(step, active, touched, !unlocked);
      });
    }

    function displayName(size) {
      return size && (size.display_name || size.label || size.key) || '';
    }

    function statusCard(message, retryAttr) {
      var card = document.createElement('div');
      card.className = 'tw:col-span-3 tw:2xl:col-span-5 tw:flex tw:flex-col tw:gap-3 tw:rounded-lg tw:border tw:border-gray-200 tw:bg-gray-50 tw:p-4 tw:text-sm tw:text-gray-700';
      var text = document.createElement('span');
      text.textContent = message;
      card.appendChild(text);
      if (retryAttr) {
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.setAttribute(retryAttr, 'true');
        retry.className = 'tw:self-start tw:rounded tw:border tw:border-gray-400 tw:bg-white tw:px-3 tw:py-1.5 tw:text-xs tw:font-semibold';
        retry.textContent = 'Try again';
        card.appendChild(retry);
      }
      return card;
    }

    function appendLoadingCards(container, count, sizeClass) {
      for (var index = 0; index < count; index += 1) {
        var card = document.createElement('div');
        card.setAttribute('aria-hidden', 'true');
        card.className = String(sizeClass || '') + ' tw:animate-pulse tw:rounded-lg tw:border tw:border-gray-200 tw:bg-gray-100';
        container.appendChild(card);
      }
    }

    function renderSizes() {
      if (!sizeList) return;
      if (sizeBar && sizeBar.parentNode) sizeBar.parentNode.removeChild(sizeBar);
      sizeBar = null;
      sizeList.innerHTML = '';
      if (sizeLoading) {
        sizeList.setAttribute('aria-label', 'Loading case sizes');
        appendLoadingCards(sizeList, 5, 'tw:min-h-[68px]');
        return;
      }
      sizeList.setAttribute('aria-label', 'Available sizes');
      if (sizeError) {
        var errorCard = statusCard(sizeError, 'data-size-retry');
        errorCard.classList.remove('tw:col-span-3', 'tw:2xl:col-span-5');
        sizeList.appendChild(errorCard);
        return;
      }
      if (!sizeStep) {
        sizeList.appendChild(statusCard('Could not display case sizes. Please refresh the page.'));
        return;
      }
      if (!state.sizes.length) return;
      var presentation = sizeStep.prepare(state.sizes.map(function (size) {
        return {
          key: size.key,
          name: displayName(size),
          thumbnail: size.thumbnail,
          shape: sizeStep.shapeFor(size.key),
          counts: size.pill_counts
        };
      }));
      if (presentation.icons) {
        sizeBar = sizeStep.createBar();
        sizeList.parentNode.insertBefore(sizeBar, sizeList);
      }
      state.sizes.forEach(function (size, index) {
        var selected = state.pendingSize === size.key;
        var button = document.createElement('button');
        button.type = 'button';
        button.disabled = !!size.sold_out;
        button.setAttribute('data-size-key', size.key);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.className = [
          'tw:border tw:bg-white tw:transition-all tw:duration-200 tw:ease-standard',
          selected ? 'tw:border-gray-950 tw:bg-gray-50 tw:ring-1 tw:ring-gray-950' : 'tw:border-gray-300',
          size.sold_out ? 'tw:cursor-not-allowed tw:border-gray-200 tw:bg-gray-50' : 'tw:cursor-pointer tw:hover:border-gray-400 tw:hover:shadow-sm'
        ].join(' ');
        sizeStep.appendRow(button, presentation.rows[index], {
          selected: selected,
          disabled: !!size.sold_out,
          multiplier: CASE_COUNT,
          badge: size.color_catalog_empty ? 'No colors are available for this selection.'
            : size.sold_out ? 'Sold out' : size.best_seller ? 'Best seller' : '',
          tone: !size.sold_out && !size.color_catalog_empty && size.best_seller ? 'best' : 'status'
        });
        sizeList.appendChild(button);
      });
    }

    function createColorSwatch(color, sizeClass) {
      var swatch = document.createElement('span');
      swatch.className = [
        'tw:relative tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:overflow-hidden tw:rounded-full tw:border tw:border-gray-200 tw:bg-gray-100',
        sizeClass || 'tw:h-9 tw:w-9'
      ].join(' ');
      if (color && color.swatch_image) {
        var image = document.createElement('img');
        image.src = color.swatch_image;
        image.alt = '';
        image.loading = 'lazy';
        image.className = 'tw:h-full tw:w-full tw:object-cover';
        swatch.appendChild(image);
      }
      if (colorIsSoldOut(color)) {
        var slash = document.createElement('span');
        slash.setAttribute('aria-hidden', 'true');
        slash.className = 'tw:pointer-events-none tw:absolute tw:left-1/2 tw:top-1/2 tw:h-0.5 tw:w-[140%] tw:-translate-x-1/2 tw:-translate-y-1/2 tw:-rotate-45 tw:bg-red-600';
        swatch.appendChild(slash);
      }
      return swatch;
    }

    function appendColorBadges(parent, color) {
      if (!color || !Array.isArray(color.badges)) return;
      color.badges.forEach(function (badge) {
        if (!badge || !badge.name) return;
        var badgeEl = document.createElement('span');
        badgeEl.className = 'tw:rounded-full tw:bg-gray-100 tw:px-1.5 tw:py-0.5 tw:text-[10px] tw:font-medium tw:leading-tight tw:text-gray-700';
        badgeEl.textContent = badge.name;
        if (badge.color) {
          badgeEl.style.backgroundColor = badge.color;
          badgeEl.style.color = '#fff';
        }
        parent.appendChild(badgeEl);
      });
    }

    function getColorPopoverTrigger(popover) {
      if (!popover) return null;
      var slot = popover.getAttribute('data-color-slot');
      return slot ? root.querySelector('[data-color-popover-trigger][data-color-slot="' + slot + '"]') : null;
    }

    function placeColorPopover(popover) {
      var trigger = getColorPopoverTrigger(popover);
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      var viewportWidth = globalScope.innerWidth || document.documentElement.clientWidth || rect.width;
      var viewportHeight = globalScope.innerHeight || document.documentElement.clientHeight || 0;
      var sidePadding = 16;
      var width = Math.min(rect.width, Math.max(viewportWidth - sidePadding * 2, 0));
      var left = Math.min(Math.max(rect.left, sidePadding), Math.max(viewportWidth - width - sidePadding, sidePadding));
      popover.style.position = 'fixed';
      popover.style.margin = '0';
      popover.style.left = left + 'px';
      popover.style.right = 'auto';
      popover.style.bottom = 'auto';
      popover.style.width = width + 'px';
      var popupHeight = popover.offsetHeight || 0;
      var spaceBelow = viewportHeight - rect.bottom;
      popover.style.top = spaceBelow < popupHeight + 16 && rect.top > popupHeight + 16
        ? (rect.top - popupHeight - 4) + 'px'
        : (rect.bottom + 4) + 'px';
    }

    function placeOpenColorPopover() {
      if (openColorPopover) placeColorPopover(openColorPopover);
    }

    function bindColorPopoverListeners() {
      if (colorPopoverListenersBound) return;
      globalScope.addEventListener('resize', placeOpenColorPopover);
      globalScope.addEventListener('scroll', placeOpenColorPopover, true);
      colorPopoverListenersBound = true;
    }

    function unbindColorPopoverListeners() {
      if (!colorPopoverListenersBound) return;
      globalScope.removeEventListener('resize', placeOpenColorPopover);
      globalScope.removeEventListener('scroll', placeOpenColorPopover, true);
      colorPopoverListenersBound = false;
    }

    function closeColorPopover(popover) {
      var target = popover || openColorPopover;
      if (!target) return;
      var trigger = getColorPopoverTrigger(target);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (typeof target.hidePopover === 'function') {
        try { target.hidePopover(); } catch (error) {}
      }
      if (openColorPopover === target) {
        openColorPopover = null;
        unbindColorPopoverListeners();
      }
    }

    function getEnabledColorOptions(popover) {
      if (!popover) return [];
      return Array.prototype.slice.call(popover.querySelectorAll('[data-color-option-key]')).filter(function (option) {
        return option.getAttribute('aria-disabled') !== 'true';
      });
    }

    function focusColorOption(option) {
      if (!option) return;
      var popover = option.closest('[data-color-popover]');
      var options = popover ? popover.querySelectorAll('[data-color-option-key]') : [];
      for (var index = 0; index < options.length; index += 1) {
        options[index].setAttribute('tabindex', options[index] === option ? '0' : '-1');
      }
      focusElementSoon(option);
      if (typeof option.scrollIntoView === 'function') option.scrollIntoView({ block: 'nearest' });
    }

    function focusInitialColorOption(popover, focusLast) {
      var options = getEnabledColorOptions(popover);
      if (!options.length) return;
      var selected = options.find(function (option) { return option.getAttribute('aria-selected') === 'true'; });
      focusColorOption(focusLast ? options[options.length - 1] : (selected || options[0]));
    }

    function openColorPopoverFromTrigger(trigger, focusLast) {
      if (!trigger) return;
      var targetId = trigger.getAttribute('popovertarget');
      var popover = targetId ? document.getElementById(targetId) : null;
      if (!popover) return;
      if (focusLast) popover.setAttribute('data-focus-last-option', 'true');
      else popover.removeAttribute('data-focus-last-option');
      placeColorPopover(popover);
      if (typeof popover.showPopover === 'function') {
        try {
          popover.showPopover();
          return;
        } catch (error) {}
      }
      focusInitialColorOption(popover, !!focusLast);
    }

    function onColorPopoverBeforeToggle(event) {
      if (event.newState === 'open') placeColorPopover(event.target);
    }

    function onColorPopoverToggle(event) {
      if (event.newState === 'open') {
        openColorPopover = event.target;
        placeColorPopover(event.target);
        bindColorPopoverListeners();
        var trigger = getColorPopoverTrigger(event.target);
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var focusLast = event.target.getAttribute('data-focus-last-option') === 'true';
        event.target.removeAttribute('data-focus-last-option');
        focusInitialColorOption(event.target, focusLast);
      } else if (openColorPopover === event.target) {
        openColorPopover = null;
        unbindColorPopoverListeners();
        var closedTrigger = getColorPopoverTrigger(event.target);
        if (closedTrigger) closedTrigger.setAttribute('aria-expanded', 'false');
      }
    }

    function createColorOption(color, selectedKey, slot) {
      var selected = color.key === selectedKey;
      var soldOut = colorIsSoldOut(color);
      var limitReached = !soldOut && !canAllocateVariant(
        color.variant,
        state.selectedVariants,
        state.cartReserved,
        slot - 1,
        getSelectionCap
      );
      var unavailable = soldOut || limitReached;
      var item = document.createElement('li');
      item.setAttribute('data-color-option-key', color.key);
      item.setAttribute('data-color-slot', String(slot));
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      item.setAttribute('aria-label', color.name + (soldOut ? ', sold out' : limitReached ? ', available quantity already selected' : '') + (selected ? ', selected' : ''));
      item.setAttribute('tabindex', '-1');
      item.className = [
        'tw:flex tw:min-h-10 tw:max-h-12 tw:items-center tw:gap-2 tw:px-3 tw:py-1.5 tw:cursor-pointer tw:transition-colors tw:duration-fast tw:ease-standard tw:hover:bg-gray-50',
        FOCUS_RING_INSET,
        'tw:aria-disabled:opacity-40 tw:aria-disabled:cursor-not-allowed tw:aria-disabled:hover:bg-transparent',
        selected ? 'tw:bg-gray-50' : ''
      ].join(' ');
      item.appendChild(createColorSwatch(color, 'tw:h-8 tw:w-8'));
      var labelWrap = document.createElement('span');
      labelWrap.className = 'tw:flex tw:min-w-0 tw:flex-1 tw:flex-wrap tw:items-center tw:gap-1.5';
      var name = document.createElement('span');
      name.className = 'tw:min-w-0 tw:truncate tw:text-sm tw:font-medium tw:text-gray-900';
      name.textContent = color.name;
      labelWrap.appendChild(name);
      appendColorBadges(labelWrap, color);
      if (soldOut || limitReached) {
        var soldOutLabel = document.createElement('span');
        soldOutLabel.className = 'tw:rounded-full tw:bg-gray-100 tw:px-1.5 tw:py-0.5 tw:text-[10px] tw:font-semibold tw:leading-tight tw:text-gray-600';
        soldOutLabel.textContent = soldOut ? 'Sold out' : 'No more available';
        labelWrap.appendChild(soldOutLabel);
      }
      item.appendChild(labelWrap);
      var check = document.createElement('span');
      check.className = 'tw:flex tw:h-4 tw:w-4 tw:flex-shrink-0 tw:items-center tw:justify-center tw:text-black' + (selected ? '' : ' tw:hidden');
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<svg class="tw:h-4 tw:w-4" viewBox="0 0 16 16" fill="currentColor"><path d="M6.5 11.4 2.6 7.5 4 6.1l2.5 2.5L12 3.1l1.4 1.4z"></path></svg>';
      item.appendChild(check);
      return item;
    }

    function appendColorPopover(parent, slot) {
      var selectedColor = state.selectedColors[slot - 1];
      var popupId = root.id + '-color-popover-' + slot;
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.setAttribute('data-color-popover-trigger', '');
      trigger.setAttribute('data-color-slot', String(slot));
      trigger.setAttribute('popovertarget', popupId);
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', popupId);
      trigger.setAttribute('aria-label', 'Pill Case #' + slot + ': ' + (selectedColor ? selectedColor.name : 'Select color'));
      trigger.className = 'tw:flex tw:w-full tw:min-h-10 tw:items-center tw:justify-between tw:gap-2 tw:rounded-md tw:border tw:border-gray-200 tw:bg-white tw:py-1.5 tw:pl-3 tw:pr-4 tw:text-left tw:cursor-pointer tw:transition-all tw:duration-fast tw:ease-standard tw:hover:border-gray-400 ' + FOCUS_RING;
      var content = document.createElement('span');
      content.className = 'tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:gap-3';
      content.appendChild(createColorSwatch(selectedColor, 'tw:h-9 tw:w-9'));
      var triggerText = document.createElement('span');
      triggerText.className = 'tw:flex tw:min-w-0 tw:flex-1 tw:flex-wrap tw:items-center tw:gap-1.5';
      var triggerName = document.createElement('span');
      triggerName.className = 'tw:min-w-0 tw:truncate tw:text-sm tw:font-semibold tw:text-gray-950';
      triggerName.textContent = selectedColor ? selectedColor.name : 'Select color';
      triggerText.appendChild(triggerName);
      appendColorBadges(triggerText, selectedColor);
      content.appendChild(triggerText);
      trigger.appendChild(content);
      var chevron = document.createElement('span');
      chevron.setAttribute('aria-hidden', 'true');
      chevron.className = 'tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:text-gray-500';
      chevron.innerHTML = '<svg class="tw:h-2 tw:w-3" viewBox="0 0 12 7" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      trigger.appendChild(chevron);
      parent.appendChild(trigger);

      var popover = document.createElement('div');
      popover.id = popupId;
      popover.setAttribute('popover', 'auto');
      popover.setAttribute('data-color-popover', '');
      popover.setAttribute('data-color-slot', String(slot));
      popover.setAttribute('role', 'listbox');
      popover.setAttribute('aria-label', 'Pill Case #' + slot + ' color');
      popover.className = 'tw:m-0 tw:border-0 tw:bg-transparent tw:p-0';
      var list = document.createElement('ul');
      list.className = 'tw:list-none tw:m-0 tw:max-h-72 tw:overflow-hidden tw:overflow-y-auto tw:rounded-lg tw:border tw:border-gray-200 tw:bg-white tw:p-0 tw:shadow-lg';
      getSortedColorList(state.colors).forEach(function (color) {
        list.appendChild(createColorOption(color, selectedColor && selectedColor.key, slot));
      });
      popover.appendChild(list);
      popover.addEventListener('beforetoggle', onColorPopoverBeforeToggle);
      popover.addEventListener('toggle', onColorPopoverToggle);
      parent.appendChild(popover);
    }

    function renderColors() {
      if (!colorList) return;
      closeColorPopover();
      colorList.innerHTML = '';
      var colorConfirm = root.querySelector('[data-step-confirm="2"]');
      if (colorConfirm) {
        colorConfirm.disabled = colorLoading
          || !!colorError
          || !state.selectedVariants.every(Boolean)
          || !selectionsBelongToCatalog()
          || !state.inventory
          || !state.inventory.ok;
      }
      if (colorLoading) {
        colorList.setAttribute('aria-label', 'Loading case colors');
        appendLoadingCards(colorList, 4, 'tw:min-h-20');
        return;
      }
      colorList.removeAttribute('aria-label');
      if (colorError) {
        colorList.appendChild(statusCard(colorError, 'data-color-retry'));
        return;
      }
      for (var slot = 1; slot <= CASE_COUNT; slot += 1) {
        var section = document.createElement('div');
        section.className = 'tw:flex tw:w-full tw:flex-col tw:gap-2';
        var label = document.createElement('span');
        label.className = 'tw:text-xs tw:font-bold tw:leading-tight tw:text-black';
        label.textContent = 'Pill Case #' + slot;
        section.appendChild(label);
        appendColorPopover(section, slot);
        colorList.appendChild(section);
      }
    }

    function getPreviewSize() {
      return state.size || state.pendingSize || previewSize;
    }

    function getPreviewSizeData() {
      var sizeKey = getPreviewSize();
      return state.sizes.find(function (size) { return size && size.key === sizeKey; }) || null;
    }

    function getSizeFallbackColor() {
      var size = getPreviewSizeData();
      if (!size) return null;
      var color = {
        key: size.preview_color_key || '',
        name: size.preview_color_name || ''
      };
      return getCaseImageSrc(color) ? color : null;
    }

    function getPreviewColor(index) {
      return state.selectedColors[index]
        || (previewSize === getPreviewSize() ? previewColor : null)
        || getSizeFallbackColor();
    }

    function getCaseImageSrc(color) {
      var resolver = globalScope && globalScope.theme && globalScope.theme.caseImages;
      return resolver && resolver.resolve(caseImagesByColor, {
        colorKey: color && color.key,
        sizeKey: getPreviewSize()
      }) || '';
    }

    function getPreviewCaseSrc(index) {
      var color = getPreviewColor(index);
      return getCaseImageSrc(color) || color && color.swatch_image || '';
    }

    function getPreviewImageWidth(context) {
      var size = PREVIEW_SIZES[getPreviewSize()] || PREVIEW_SIZES['weekly-pill-case'];
      var compact = getPreviewSize() === 'weekly-xs-case' || getPreviewSize() === 'weekly-pill-case';
      if (context === 'colorHeader') return compact ? '64px' : '72px';
      if (context === 'lidHeader') return compact ? '200px' : '220px';
      if (context === 'body') return size.body;
      var narrow = globalScope.matchMedia && globalScope.matchMedia('(max-width: 767px)').matches;
      return narrow ? size.mainMobile : size.main;
    }

    function createLidPreviewLabel(value, context, colorName) {
      var label = document.createElement('span');
      var style = getLidPreviewLabelStyle(colorName);
      var sizes = LID_PREVIEW_FONT_SIZES[getPreviewSize()] || LID_PREVIEW_FONT_SIZES['weekly-pill-case'];
      var narrow = globalScope.matchMedia && globalScope.matchMedia('(max-width: 767px)').matches;
      var fontSize = context === 'lidHeader'
        ? sizes.header
        : context === 'body' ? sizes.body : narrow ? sizes.mainMobile : sizes.main;
      label.setAttribute('aria-hidden', 'true');
      label.className = 'tw:absolute tw:left-1/2 tw:top-1/2 tw:flex tw:h-1/3 tw:w-[96%] tw:-translate-x-1/2 tw:-translate-y-1/2 tw:items-center tw:justify-center tw:text-center tw:leading-none';
      label.style.fontSize = fontSize + 'px';
      label.style.whiteSpace = 'nowrap';
      label.style.color = style.color;
      label.style.setProperty('-webkit-text-stroke', style.textStroke);
      label.textContent = value;
      return label;
    }

    function createPreviewCase(index, context) {
      var src = getPreviewCaseSrc(index);
      if (!src) return null;
      var width = getPreviewImageWidth(context);
      var clip = document.createElement('span');
      clip.className = 'tw:relative tw:block';
      clip.style.width = width;
      clip.style.lineHeight = '0';
      var image = document.createElement('img');
      image.src = src;
      image.alt = '';
      image.decoding = 'async';
      image.loading = context === 'main' ? 'eager' : 'lazy';
      image.className = 'tw:block tw:h-auto tw:max-w-none tw:object-contain';
      image.style.width = width;
      image.style.maxWidth = 'none';
      image.style.borderRadius = context === 'main' ? PREVIEW_RADIUS : '';
      image.style.boxShadow = context === 'main'
        ? '5px 5px 15px rgba(0, 0, 0, 0.8)'
        : context === 'body' ? '2px 2px 7px rgba(0, 0, 0, 0.35)' : '';
      clip.appendChild(image);
      if (state.lidChoice === 'add' && context !== 'colorHeader') {
        var color = getPreviewColor(index);
        clip.appendChild(createLidPreviewLabel('WEEK ' + (index + 1), context, color && color.name));
      }
      return clip;
    }

    function createPreviewStack(context) {
      var stack = document.createElement('span');
      stack.className = 'tw:flex tw:flex-col tw:items-center tw:justify-center';
      stack.style.gap = context === 'main' ? '10px' : context === 'body' ? '5px' : '2px';
      for (var index = 0; index < CASE_COUNT; index += 1) {
        var previewCase = createPreviewCase(index, context);
        if (!previewCase) return null;
        stack.appendChild(previewCase);
      }
      return stack;
    }

    function mountPreview(frame, stack) {
      if (!frame) return;
      frame.innerHTML = '';
      if (!stack) {
        frame.classList.add('tw:hidden');
        frame.style.display = 'none';
        return;
      }
      frame.classList.remove('tw:hidden');
      frame.style.position = 'absolute';
      frame.style.top = '50%';
      frame.style.left = '50%';
      frame.style.transform = 'translate(-50%, -50%)';
      frame.style.pointerEvents = 'none';
      frame.style.zIndex = '10';
      frame.style.display = 'flex';
      frame.style.alignItems = 'center';
      frame.style.justifyContent = 'center';
      frame.appendChild(stack);
    }

    function renderGalleryPreview() {
      var sizeKey = getPreviewSize();
      var ready = !!sizeKey && Array.from({ length: CASE_COUNT }).every(function (_, index) {
        return !!getPreviewCaseSrc(index);
      });
      if (primaryMedia) {
        var nextSrc = sizeKey ? (config.galleryBackgroundSrc || '') : initialPrimarySrc;
        if (nextSrc) primaryMedia.setAttribute('src', nextSrc);
        else primaryMedia.removeAttribute('src');
        primaryMedia.alt = sizeKey ? '' : initialPrimaryAlt;
        primaryMedia.style.display = nextSrc ? '' : 'none';
      }
      if (primaryPlaceholder) primaryPlaceholder.classList.toggle('tw:hidden', ready);
      mountPreview(previewFrame, ready ? createPreviewStack('main') : null);
      if (galleryStage) {
        var selectedSize = getPreviewSizeData();
        var sizeName = selectedSize ? displayName(selectedSize) : 'Weekly';
        var colors = Array.from({ length: CASE_COUNT }).map(function (_, index) {
          var color = getPreviewColor(index);
          return color && color.name;
        }).filter(Boolean);
        galleryStage.setAttribute('aria-label', ready
          ? 'Monthly Pill Case Bundle preview: four separate ' + sizeName + ' cases in ' + colors.join(', ') + '.'
          : initialPrimaryAlt);
      }
    }

    function loadPendingSizePreview(sizeKey) {
      previewSize = sizeKey;
      previewColor = null;
      previewRequestId += 1;
      var requestId = previewRequestId;
      renderGalleryPreview();

      if (!globalScope.theme || !globalScope.theme.productDataFetcher) return Promise.resolve(null);
      var args = buildColorFetchArgs(config.caseProductHandle, sizeKey, config.listingContext);
      return globalScope.theme.productDataFetcher.fetch.apply(globalScope.theme.productDataFetcher, args)
        .then(function (payload) {
          if (requestId !== previewRequestId || state.pendingSize !== sizeKey) return payload;
          if (!payload || payload.error || payload.handle !== config.caseProductHandle
            || payload.family !== 'single' || payload.size_key !== sizeKey
            || payload.listing_context !== config.listingContext || !Array.isArray(payload.colors)) {
            return null;
          }
          previewColor = getDefaultColor(payload.colors.filter(function (color) {
            return color && color.key && color.variant;
          }), state.cartReserved, CASE_COUNT, getSelectionCap);
          renderGalleryPreview();
          return payload;
        })
        .catch(function () {
          if (requestId === previewRequestId && state.pendingSize === sizeKey) {
            previewColor = null;
            renderGalleryPreview();
          }
          return null;
        });
    }

    function renderLidBodyPreview() {
      var preview = root.querySelector('[data-lid-body-preview]');
      if (!preview) return;
      preview.innerHTML = '';
      var stack = createPreviewStack('body');
      if (stack) preview.appendChild(stack);
    }

    function orderedPocketDays() {
      return orderedDayCodes(state.startDay);
    }

    function getPocketPreviewRows() {
      var engraved = state.pocketChoice === 'add';
      var weekdays = engraved ? orderedPocketDays() : [];
      return Array.from({ length: CASE_COUNT }).map(function (_, index) {
        return {
          index: index,
          slotLabel: 'Pill Case #' + (index + 1),
          weekdays: engraved ? weekdays.slice() : []
        };
      });
    }

    function getPocketBodyPreviewSrc(index) {
      var color = getPreviewColor(index);
      var colorKey = color && color.key || '';
      var images = pocketImagesByColor[colorKey];
      return images && images.weekly || '';
    }

    function getPocketSummaryBackgroundSrc(index) {
      return getPreviewCaseSrc(index);
    }

    function getPocketPreviewAreas() {
      return [6.5, 18.5, 31, 44, 56.5, 69, 81.5].map(function (top) {
        return { top: top + '%', left: '50%', width: '34px' };
      });
    }

    function createPocketBodyPreviewLabel(primaryText, area) {
      var primary = String(primaryText || '').trim().toUpperCase();
      var label = document.createElement('span');
      label.setAttribute('aria-hidden', 'true');
      label.className = 'tw:absolute tw:flex tw:items-center tw:justify-center tw:truncate tw:text-center tw:leading-none tw:text-neutral-200';
      label.style.left = area.left;
      label.style.top = area.top;
      label.style.transform = 'translate(-50%, -50%)';
      label.style.width = area.width;
      label.style.maxWidth = area.width;
      label.style.whiteSpace = 'nowrap';
      label.style.fontSize = '12px';
      label.textContent = primary;
      return label;
    }

    function createPocketBodyPreviewFrame(row) {
      var frame = document.createElement('span');
      var src = getPocketBodyPreviewSrc(row.index);
      var ariaValues = row.weekdays.map(function (day) {
        return day;
      });
      frame.setAttribute('data-pocket-body-preview-frame', '');
      frame.setAttribute('role', 'img');
      frame.setAttribute('aria-label', row.slotLabel + (ariaValues.length
        ? ' pocket engraving preview: ' + ariaValues.join(', ')
        : ' pocket engraving preview'));
      frame.className = 'tw:relative tw:inline-flex tw:flex-shrink-0 tw:items-center tw:justify-center tw:overflow-hidden tw:rounded-sm tw:bg-white';
      frame.style.width = '42px';
      frame.style.maxWidth = '100%';

      if (src) {
        var image = document.createElement('img');
        image.src = src;
        image.alt = '';
        image.loading = 'lazy';
        image.className = 'tw:block tw:h-auto tw:w-full tw:object-contain';
        frame.appendChild(image);
      } else {
        frame.style.aspectRatio = '1 / 1';
      }

      var areas = getPocketPreviewAreas();
      row.weekdays.forEach(function (day, index) {
        frame.appendChild(createPocketBodyPreviewLabel(day, areas[index]));
      });
      return frame;
    }

    function applyPocketSummaryBackground(element, index) {
      var src = getPocketSummaryBackgroundSrc(index);
      if (!src) return;
      var safeSrc = encodeURI(String(src)).replace(/"/g, '%22');
      element.style.backgroundImage = 'url("' + safeSrc + '")';
      element.style.backgroundSize = 'cover';
      element.style.backgroundPosition = 'center';
      element.style.color = '#fff';
    }

    function createPocketSummaryPill(text, rowIndex) {
      var labelText = String(text || '').trim();
      var pill = document.createElement('span');
      pill.setAttribute('data-monthly-pocket-summary-pill', '');
      pill.className = 'tw:inline-flex tw:min-h-6 tw:w-full tw:min-w-[45px] tw:max-w-full tw:shrink tw:items-center tw:justify-center tw:truncate tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:px-1.5 tw:py-1 tw:text-[11px] tw:font-semibold tw:leading-none tw:text-gray-900 tw:sm:w-auto tw:sm:max-w-28 tw:sm:shrink-0 tw:sm:px-2';
      applyPocketSummaryBackground(pill, rowIndex);
      if (labelText) {
        pill.textContent = labelText;
      } else {
        pill.innerHTML = '&nbsp;';
      }
      return pill;
    }

    function createPocketSummaryPillRow(row) {
      var line = document.createElement('span');
      var pills = document.createElement('span');
      var values = row.weekdays.length
        ? row.weekdays.slice()
        : Array.from({ length: 7 }).map(function () { return ''; });
      line.setAttribute('data-monthly-pocket-summary-row', '');
      line.className = 'tw:flex tw:w-full tw:min-w-0 tw:items-start tw:gap-1.5 tw:sm:items-center';
      pills.className = 'tw:grid tw:w-full tw:min-w-0 tw:grid-cols-[repeat(auto-fit,minmax(2.15rem,1fr))] tw:gap-1 tw:sm:flex tw:sm:flex-wrap tw:sm:items-center';
      values.forEach(function (value) {
        pills.appendChild(createPocketSummaryPill(value, row.index));
      });
      line.appendChild(pills);
      return line;
    }

    function createPocketStepSummaryPreview(rows) {
      var wrap = document.createElement('span');
      wrap.setAttribute('data-monthly-pocket-summary-wrap', '');
      wrap.className = 'tw:flex tw:w-full tw:min-w-0 tw:flex-col tw:gap-1';
      rows.forEach(function (row) {
        wrap.appendChild(createPocketSummaryPillRow(row));
      });
      return wrap;
    }

    function renderPocketBodyPreview() {
      var preview = root.querySelector('[data-pocket-body-preview]');
      if (!preview) return;
      preview.innerHTML = '';
      var wrap = document.createElement('span');
      wrap.className = 'tw:inline-flex tw:max-w-full tw:flex-shrink-0 tw:items-center tw:justify-center';
      getPocketPreviewRows().forEach(function (row) {
        wrap.appendChild(createPocketBodyPreviewFrame(row));
      });
      preview.appendChild(wrap);
    }

    function renderChoices() {
      root.querySelectorAll('[data-lid-option]').forEach(function (button) {
        var selected = button.getAttribute('data-lid-option') === state.lidChoice;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('tw:border-gray-950', selected);
        button.classList.toggle('tw:bg-gray-950', selected);
        button.classList.toggle('tw:text-white', selected);
        button.classList.toggle('tw:border-gray-300', !selected);
        button.classList.toggle('tw:bg-white', !selected);
        button.classList.toggle('tw:text-gray-900', !selected);
        button.classList.toggle('tw:cursor-pointer', !selected);
        button.classList.toggle('tw:hover:bg-gray-50', !selected);
      });
      root.querySelectorAll('[data-pocket-option]').forEach(function (button) {
        var selected = button.getAttribute('data-pocket-option') === state.pocketChoice;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('tw:border-gray-950', selected);
        button.classList.toggle('tw:bg-gray-950', selected);
        button.classList.toggle('tw:text-white', selected);
        button.classList.toggle('tw:border-gray-300', !selected);
        button.classList.toggle('tw:bg-white', !selected);
        button.classList.toggle('tw:text-gray-900', !selected);
        button.classList.toggle('tw:cursor-pointer', !selected);
        button.classList.toggle('tw:hover:bg-gray-50', !selected);
      });
      var startWrap = root.querySelector('[data-start-day-wrap]');
      if (startWrap) {
        startWrap.classList.toggle('tw:hidden', state.pocketChoice !== 'add');
        startWrap.classList.toggle('tw:flex', state.pocketChoice === 'add');
      }
      var startSelect = root.querySelector('[data-start-day]');
      if (startSelect) startSelect.value = state.startDay;
      renderGalleryPreview();
      renderLidBodyPreview();
      renderPocketBodyPreview();
    }

    function ready() {
      return fixedCatalog.ok
        && state.confirmed.size
        && state.confirmed.colors
        && state.confirmed.lid
        && state.confirmed.pocket
        && state.selectedVariants.every(Boolean)
        && selectionsBelongToCatalog()
        && state.inventory
        && state.inventory.ok
        && !state.adding;
    }

    function refreshAtc() {
      var isReady = ready();
      if (atc) atc.disabled = !isReady;
      if (atcLabel) atcLabel.textContent = state.adding
        ? 'Adding…'
        : isReady ? 'Add to Cart' : 'Configure Your Bundle First';
    }

    function selectionsBelongToCatalog() {
      if (!state.colors.length) return false;
      return state.selectedColors.every(function (selectedColor, index) {
        var selectedVariant = state.selectedVariants[index];
        if (!selectedColor || !selectedVariant) return false;
        return state.colors.some(function (catalogColor) {
          return catalogColor
            && catalogColor.key === selectedColor.key
            && catalogColor.variant
            && String(catalogColor.variant.id) === String(selectedVariant.id);
        });
      });
    }

    function renderAll() {
      renderSizes();
      renderColors();
      renderChoices();
      renderSteps();
      refreshStock();
      refreshAtc();
    }

    function expectedSizes(payload) {
      var byKey = {};
      (payload && payload.sizes || []).forEach(function (size) { byKey[size.key] = size; });
      var keys = orderSizeKeys(Object.keys(SIZE_KEY_CODES), sizeOrder);
      if (keys.some(function (key) { return !byKey[key]; })) return null;
      return keys.map(function (key) {
        var size = byKey[key];
        return Object.assign({}, size, { color_catalog_empty: size.base_price == null });
      });
    }

    function fetchSizes(force) {
      if (!globalScope.theme || !globalScope.theme.productDataFetcher) {
        sizeError = 'Product data helper is unavailable.';
        renderAll();
        return Promise.resolve(null);
      }
      var args = buildSizeFetchArgs(config.caseProductHandle, config.listingContext);
      if (force && typeof globalScope.theme.productDataFetcher.invalidate === 'function') {
        globalScope.theme.productDataFetcher.invalidate.apply(globalScope.theme.productDataFetcher, args);
      }
      sizeLoading = true;
      sizeError = '';
      renderAll();
      return globalScope.theme.productDataFetcher.fetch.apply(globalScope.theme.productDataFetcher, args)
        .then(function (payload) {
          if (!payload || payload.error) {
            var reason = payload && payload.reason ? ': ' + String(payload.reason).replace(/_/g, ' ') : '';
            throw new Error('Could not load Weekly Case sizes' + reason + '.');
          }
          var sizes = expectedSizes(payload);
          if (payload.handle !== config.caseProductHandle || payload.family !== 'single'
            || payload.listing_context !== config.listingContext || !sizes) {
            throw new Error('The Weekly Case size catalog is incomplete.');
          }
          state.sizes = sizes;
          if (state.size) {
            var refreshedSize = state.sizes.find(function (size) { return size.key === state.size; });
            if (!refreshedSize || refreshedSize.sold_out) {
              var previousSizeKey = state.size;
              invalidateAfter(state, 'size');
              state.pendingSize = previousSizeKey;
              activeStep = '1';
              setValidation('1', refreshedSize && refreshedSize.color_catalog_empty
                ? 'No colors are available for this selection.'
                : 'Choose an available size.');
            }
          }
          sizeLoading = false;
          renderAll();
          return payload;
        })
        .catch(function (error) {
          sizeLoading = false;
          sizeError = error && error.message ? error.message : 'Could not load sizes.';
          renderAll();
          return null;
        });
    }

    function fetchColors(force) {
      if (!state.size) return Promise.resolve(null);
      var args = buildColorFetchArgs(config.caseProductHandle, state.size, config.listingContext);
      if (force && typeof globalScope.theme.productDataFetcher.invalidate === 'function') {
        globalScope.theme.productDataFetcher.invalidate.apply(globalScope.theme.productDataFetcher, args);
      }
      colorLoading = true;
      colorError = '';
      var preferredSelections = state.selectedColors.slice();
      state.colors = [];
      state.selectedColors = [null, null, null, null];
      state.selectedVariants = [null, null, null, null];
      invalidateAfter(state, 'colors');
      state.inventory = null;
      renderAll();
      return globalScope.theme.productDataFetcher.fetch.apply(globalScope.theme.productDataFetcher, args)
        .then(function (payload) {
          if (!payload || payload.error) {
            var reason = payload && payload.reason ? ': ' + String(payload.reason).replace(/_/g, ' ') : '';
            throw new Error('Could not load Weekly Case colors' + reason + '.');
          }
          if (payload.handle !== config.caseProductHandle || payload.family !== 'single'
            || payload.size_key !== state.size || payload.listing_context !== config.listingContext
            || !Array.isArray(payload.colors)) {
            throw new Error('The Weekly Case color catalog is unavailable.');
          }
          state.colors = payload.colors.filter(function (color) { return color && color.key && color.variant; });
          if (!state.colors.length) throw new Error('No colors are available for this selection.');
          return loadCart().then(function (cart) {
            state.cartItems = cart.items || [];
            state.cartReserved = reservedQuantities(state.cartItems);
            state.selectedColors = allocateColorSelections(
              state.colors,
              preferredSelections,
              state.cartReserved,
              CASE_COUNT,
              getSelectionCap
            );
            state.selectedVariants = state.selectedColors.map(function (color) {
              return color && color.variant || null;
            });
            state.inventory = validateSelectedInventory(state.cartItems);
            colorLoading = false;
            renderAll();
            return payload;
          });
        })
        .catch(function (error) {
          colorLoading = false;
          colorError = error && error.message ? error.message : 'Could not load colors.';
          renderAll();
          return null;
        });
    }

    function loadCart() {
      return fetch(cartRoute('cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (response) { return parseResponse(response, 'Could not read the current cart.'); });
    }

    function validateSelectedInventory(cartItems) {
      var inventory = validateAggregateInventory(state.selectedVariants, cartItems || []);
      if (inventory.preorderVariantIds.length && (!config.preorderEnabled || !String(config.preorderEta || '').trim())) {
        inventory.ok = false;
        inventory.issues.unshift('This preorder selection is not configured yet. Choose another color.');
      }
      return inventory;
    }

    function confirmColors() {
      if (colorLoading || colorError || !state.colors.length) {
        setValidation('2', colorError || 'Wait for the available colors to finish loading.');
        return;
      }
      if (!state.selectedVariants.every(Boolean)) {
        setValidation('2', 'Choose an available color for all four cases.');
        return;
      }
      if (!selectionsBelongToCatalog()) {
        setValidation('2', 'One or more selected colors are no longer available. Please choose again.');
        return;
      }
      state.inventory = validateSelectedInventory(state.cartItems);
      if (!state.inventory.ok) {
        setValidation('2', state.inventory.issues[0]);
        renderAll();
        return;
      }
      state.confirmed.colors = true;
      setValidation('2', '');
      activeStep = '3';
      renderAll();
      focusElementSoon(root.querySelector('[data-step-header="3"]'));
    }

    function confirmStep(step) {
      if (step === '1') {
        var selectedSize = state.sizes.find(function (size) { return size.key === state.pendingSize; });
        if (!selectedSize || selectedSize.sold_out) {
          setValidation('1', selectedSize && selectedSize.color_catalog_empty
            ? 'No colors are available for this selection.'
            : 'Choose an available size.');
          return;
        }
        var changed = state.size !== selectedSize.key;
        if (changed) {
          invalidateAfter(state, 'size');
          state.pendingSize = selectedSize.key;
        }
        state.size = selectedSize.key;
        state.confirmed.size = true;
        setValidation('1', '');
        activeStep = '2';
        renderAll();
        focusElementSoon(root.querySelector('[data-step-header="2"]'));
        fetchColors(false);
        return;
      }
      if (step === '2') {
        confirmColors();
        return;
      }
      if (step === '3') {
        var sizeCode = SIZE_KEY_CODES[state.size];
        if (!sizeCode || !findExactVariant(lidProduct, LID_RULES[sizeCode])) {
          setValidation('3', 'The included lid engraving is unavailable for this size.');
          return;
        }
        state.confirmed.lid = true;
        setValidation('3', '');
        activeStep = '4';
        renderAll();
        focusElementSoon(root.querySelector('[data-step-header="4"]'));
        return;
      }
      if (step === '4') {
        if (state.pocketChoice === 'add' && !findExactVariant(pocketProduct, POCKET_RULES[SIZE_KEY_CODES[state.size]])) {
          setValidation('4', 'The included pocket engraving is unavailable for this size.');
          return;
        }
        state.confirmed.pocket = true;
        setValidation('4', '');
        activeStep = null;
        renderAll();
      }
    }

    function addToCart() {
      if (!ready()) return;
      state.adding = true;
      if (atcSpinner) atcSpinner.classList.remove('tw:hidden');
      setMessage('');
      refreshAtc();

      loadCart().then(function (cart) {
        state.cartItems = cart.items || [];
        state.cartReserved = reservedQuantities(state.cartItems);
        var inventory = validateSelectedInventory(state.cartItems);
        state.inventory = inventory;
        if (!inventory.ok) throw new Error(inventory.issues[0]);
        var sizeCode = SIZE_KEY_CODES[state.size];
        var lidVariant = findExactVariant(lidProduct, LID_RULES[sizeCode]);
        var pocketVariant = findExactVariant(pocketProduct, POCKET_RULES[sizeCode]);
        var items = buildCartItems({
          bundleId: createBundleId(),
          bundleNumber: getNextMonthlyBundleNumber(cart.items || []),
          carrierVariantId: config.carrierVariantId,
          listingContext: config.listingContext,
          sizeCode: sizeCode,
          cases: state.selectedVariants.map(function (variant, index) { return { slot: index + 1, variant: variant }; }),
          lid: state.lidChoice === 'add' ? { variant: lidVariant } : null,
          pocket: state.pocketChoice === 'add' ? { variant: pocketVariant } : null,
          startDay: state.startDay,
          preorderEta: config.preorderEnabled ? config.preorderEta : '',
          preorderVariantIds: inventory.preorderVariantIds
        });
        return fetch(cartRoute('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (response) {
          return parseResponse(response, 'Could not add the Monthly bundle.');
        }).then(function (payload) {
          var inspection = inspectCartAddResponse(payload, items);
          if (!inspection.ok) {
            throw new Error('Shopify did not preserve the Monthly bundle relationship. Open the cart and remove the incomplete bundle.');
          }
          globalScope.location.href = cartRoute('cart');
        });
      }).catch(function (error) {
        state.adding = false;
        if (atcSpinner) atcSpinner.classList.add('tw:hidden');
        setMessage(error && error.message ? error.message : 'Could not add the Monthly bundle.');
        renderAll();
      });
    }

    function closeCompareTooltip(callback) {
      if (!currentTooltip) {
        currentTooltipTrigger = null;
        if (callback) callback();
        return;
      }
      var tooltip = currentTooltip;
      if (tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
      if (currentTooltip === tooltip) currentTooltip = null;
      currentTooltipTrigger = null;
      if (callback) callback();
    }

    function showCompareTooltip(trigger) {
      var tooltipUrl = trigger && trigger.getAttribute('data-tooltip');
      if (!tooltipUrl) return;
      var tooltip = document.createElement('div');
      tooltip.className = 'dynamic-tooltip';
      tooltip.style.backgroundImage = 'url("' + tooltipUrl.replace(/"/g, '\\"') + '")';
      tooltip.style.position = 'absolute';
      tooltip.style.display = 'none';
      document.body.appendChild(tooltip);
      currentTooltip = tooltip;
      currentTooltipTrigger = trigger;
      var viewportWidth = globalScope.innerWidth || document.documentElement.clientWidth || 0;
      var isMobile = viewportWidth <= 768;
      var imageWidth = isMobile ? viewportWidth * 0.85 : 750;
      var image = new Image();
      image.onload = function () {
        if (currentTooltip !== tooltip) return;
        var naturalWidth = image.naturalWidth || image.width || imageWidth;
        var naturalHeight = image.naturalHeight || image.height || imageWidth;
        if (!isMobile && naturalWidth < 750) imageWidth = naturalWidth;
        var imageHeight = imageWidth / naturalWidth * naturalHeight;
        var rect = trigger.getBoundingClientRect();
        var scrollTop = globalScope.pageYOffset || document.documentElement.scrollTop || 0;
        tooltip.style.width = imageWidth + 'px';
        tooltip.style.height = imageHeight + 'px';
        tooltip.style.top = rect.top + scrollTop + 20 + 'px';
        tooltip.style.left = Math.max((viewportWidth - imageWidth) / 2, 0) + 'px';
        tooltip.style.display = 'block';
      };
      image.onerror = function () {
        if (currentTooltip === tooltip) closeCompareTooltip();
      };
      image.src = tooltipUrl;
    }

    function toggleCompareTooltip(trigger) {
      if (currentTooltipTrigger === trigger) {
        closeCompareTooltip();
        return;
      }
      closeCompareTooltip(function () { showCompareTooltip(trigger); });
    }

    root.addEventListener('keydown', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;
      var colorOption = event.target.closest('[data-color-option-key]');
      if (colorOption && root.contains(colorOption)) {
        var popover = colorOption.closest('[data-color-popover]');
        var options = getEnabledColorOptions(popover);
        var currentIndex = Math.max(options.indexOf(colorOption), 0);
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          if (options.length) focusColorOption(options[(currentIndex + 1) % options.length]);
          return;
        }
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          if (options.length) focusColorOption(options[(currentIndex - 1 + options.length) % options.length]);
          return;
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          if (options.length) focusColorOption(event.key === 'Home' ? options[0] : options[options.length - 1]);
          return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          colorOption.click();
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          closeColorPopover(popover);
          focusElementSoon(getColorPopoverTrigger(popover));
        }
        return;
      }
      var trigger = event.target.closest('[data-color-popover-trigger]');
      if (trigger && root.contains(trigger) && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        openColorPopoverFromTrigger(trigger, event.key === 'ArrowUp');
      }
    });

    root.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('[data-size-key]');
      if (sizeButton && root.contains(sizeButton) && !sizeButton.disabled) {
        var nextSize = sizeButton.getAttribute('data-size-key');
        if (state.confirmed.size && state.size !== nextSize) invalidateAfter(state, 'size');
        state.pendingSize = nextSize;
        activeStep = '1';
        setValidation('1', '');
        renderAll();
        loadPendingSizePreview(nextSize);
        return;
      }
      var colorTrigger = event.target.closest('[data-color-popover-trigger]');
      if (colorTrigger && root.contains(colorTrigger)) {
        var targetId = colorTrigger.getAttribute('popovertarget');
        var targetPopover = targetId ? document.getElementById(targetId) : null;
        if (targetPopover) placeColorPopover(targetPopover);
        return;
      }
      var colorOption = event.target.closest('[data-color-option-key]');
      if (colorOption && root.contains(colorOption)) {
        event.preventDefault();
        if (colorOption.getAttribute('aria-disabled') === 'true') return;
        var slot = Number(colorOption.getAttribute('data-color-slot'));
        var colorKey = colorOption.getAttribute('data-color-option-key');
        var color = state.colors.find(function (entry) { return entry.key === colorKey; }) || null;
        if (!color || colorIsSoldOut(color) || slot < 1 || slot > CASE_COUNT) return;
        closeColorPopover(colorOption.closest('[data-color-popover]'));
        state.selectedColors[slot - 1] = color;
        state.selectedVariants[slot - 1] = color.variant;
        invalidateAfter(state, 'colors');
        state.inventory = validateSelectedInventory(state.cartItems);
        setValidation('2', '');
        renderAll();
        focusElementSoon(root.querySelector('[data-color-popover-trigger][data-color-slot="' + slot + '"]'));
        return;
      }
      var compareTrigger = event.target.closest('[data-compare-tooltip]');
      if (compareTrigger && root.contains(compareTrigger)) {
        event.preventDefault();
        event.stopPropagation();
        toggleCompareTooltip(compareTrigger);
        return;
      }
      var header = event.target.closest('[data-step-header]');
      if (header && root.contains(header)) {
        event.preventDefault();
        var headerStep = header.getAttribute('data-step-header');
        if (!stepUnlocked(headerStep)) return;
        if (activeStep === headerStep) confirmStep(headerStep);
        else openStep(headerStep);
        return;
      }
      var confirm = event.target.closest('[data-step-confirm]');
      if (confirm && root.contains(confirm)) {
        confirmStep(confirm.getAttribute('data-step-confirm'));
        return;
      }
      var lidOption = event.target.closest('[data-lid-option]');
      if (lidOption && root.contains(lidOption)) {
        state.lidChoice = lidOption.getAttribute('data-lid-option');
        invalidateAfter(state, 'lid');
        renderAll();
        return;
      }
      var pocketOption = event.target.closest('[data-pocket-option]');
      if (pocketOption && root.contains(pocketOption)) {
        state.pocketChoice = pocketOption.getAttribute('data-pocket-option');
        invalidateAfter(state, 'pocket');
        renderAll();
        return;
      }
      if (event.target.closest('[data-size-retry]')) fetchSizes(true);
      if (event.target.closest('[data-color-retry]')) fetchColors(true);
      if (event.target.closest('[data-add-to-cart]')) addToCart();
    });

    root.addEventListener('change', function (event) {
      var day = event.target.closest('[data-start-day]');
      if (day && root.contains(day)) {
        state.startDay = DAYS.indexOf(day.value) >= 0 ? day.value : 'Sunday';
        invalidateAfter(state, 'pocket');
        renderAll();
      }
    });

    document.addEventListener('click', function (event) {
      if (currentTooltip && !event.target.closest('[data-compare-tooltip], .dynamic-tooltip')) closeCompareTooltip();
    });

    if (!fixedCatalog.ok && configError) {
      configError.textContent = fixedCatalog.issues[0];
      configError.classList.remove('tw:hidden');
    }
    var price = root.querySelector('[data-price]');
    if (price) price.textContent = config.bundlePriceFormatted || '';
    if (globalScope.matchMedia) {
      var previewWidthQuery = globalScope.matchMedia('(max-width: 767px)');
      var refreshPreviewWidth = function () {
        renderGalleryPreview();
        renderLidBodyPreview();
      };
      if (previewWidthQuery.addEventListener) previewWidthQuery.addEventListener('change', refreshPreviewWidth);
      else if (previewWidthQuery.addListener) previewWidthQuery.addListener(refreshPreviewWidth);
    }
    renderAll();
    fetchSizes(false);
    return { state: state, refresh: renderAll };
  }

  function readJson(id) {
    if (!globalScope || !globalScope.document || !id) return null;
    var el = globalScope.document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse((el.textContent || '').trim());
    } catch (error) {
      return null;
    }
  }

  function initFrom(scope) {
    if (!globalScope || !globalScope.document) return;
    var container = scope && scope.querySelectorAll ? scope : globalScope.document;
    var roots = container.matches && container.matches('[data-product-bundle-v2]')
      ? [container]
      : Array.prototype.slice.call(container.querySelectorAll('[data-product-bundle-v2]'));
    roots.forEach(function (root) {
      var configId = root.getAttribute('data-config-id');
      var config = readJson(configId);
      if (!config) return;
      config.lidProduct = readJson(config.lidProductJsonId);
      config.pocketProduct = readJson(config.pocketProductJsonId);
      config.pocketImages = readJson(config.pocketImagesJsonId) || {};
      config.caseImages = readJson('case-images-json-' + config.sectionId) || {};
      init(root, config);
    });
  }

  if (globalScope && globalScope.document) {
    if (globalScope.document.readyState === 'loading') {
      globalScope.document.addEventListener('DOMContentLoaded', function () { initFrom(globalScope.document); });
    } else {
      initFrom(globalScope.document);
    }
    globalScope.document.addEventListener('shopify:section:load', function (event) { initFrom(event.target); });
  }

  return {
    PREFIX: PREFIX,
    CASE_COUNT: CASE_COUNT,
    CARRIER_VARIANT_IDS: CARRIER_VARIANT_IDS,
    CASE_FETCH_TIER: CASE_FETCH_TIER,
    SIZE_KEY_CODES: SIZE_KEY_CODES,
    LID_RULES: LID_RULES,
    POCKET_RULES: POCKET_RULES,
    parseMarker: parseMarker,
    buildMarker: buildMarker,
    createBundleIdFactory: createBundleIdFactory,
    getNextMonthlyBundleNumber: getNextMonthlyBundleNumber,
    getSellableCap: getSellableCap,
    aggregateDemand: aggregateDemand,
    reservedQuantities: reservedQuantities,
    validateAggregateInventory: validateAggregateInventory,
    buildSizeFetchArgs: buildSizeFetchArgs,
    buildColorFetchArgs: buildColorFetchArgs,
    getSortedColorList: getSortedColorList,
    getRemainingSellableCap: getRemainingSellableCap,
    countVariantSelections: countVariantSelections,
    canAllocateVariant: canAllocateVariant,
    getDefaultColor: getDefaultColor,
    allocateColorSelections: allocateColorSelections,
    orderedDayCodes: orderedDayCodes,
    parseSizeOrder: parseSizeOrder,
    orderSizeKeys: orderSizeKeys,
    validateFixedCatalog: validateFixedCatalog,
    buildCartItems: buildCartItems,
    inspectCartAddResponse: inspectCartAddResponse,
    createState: createState,
    invalidateAfter: invalidateAfter,
    init: init,
    initFrom: initFrom
  };
});
